export const environment = {
  name: 'qa',
  apiUrl: 'https://qa.trueface.co.in',
  production: false
};
